import Oops from "../../pages/shared/Oops.vue";
import RouteView from "../../pages/general/RouteView.vue";

function fallback (component) {
  return function (error) {
    if (error) {
      console.error(error);
    }
    return component;
  };
}

const routes = [
  {
    path: "*",
    name: "home",
    redirect: "/retail/find/order"
  },
  {
    path: "/general",
    component: () => import("../../pages/general/GeneralPageWithNavigation.vue").catch(fallback(RouteView)),
    children: [
      // a placeholder route to link to for buttons or actions that do not yet
      // exist
      {
        path: "justkidding",
        name: "justKidding",
        component: () => import("../../pages/shared/JustKidding.vue").catch(fallback(Oops))
      },
      // the login page
      {
        path: "login",
        name: "login",
        component: () => import("../../pages/general/LogIn.vue").catch(fallback(Oops))
      }
    ]
  },
  {
    path: "/receiving",
    name: "retailReceivingTool",
    component: () => import("../../pages/receiving/Receiving.vue").catch(fallback(Oops))
  },
  {
    path: "/return-creator-handoff",
    name: "returnCreatorHandoff",
    component: () => import("../../pages/returns/ReturnCreatorHandoff.vue").catch(fallback(Oops))
  },
  {
    path: "/retail",
    component: () => import("../../pages/retail/RetailLayout.vue").catch(fallback(RouteView)),
    children: [
      {
        path: "orders/:orderNumber",
        name: "retailOrder",
        component: () => import("../../pages/retail/RetailOrders.vue").catch(fallback(Oops))
      },
      {
        path: "sneak-peek/:frameSpecId",
        name: "sneakPeek",
        component: () => import("../../pages/retail/SneakPeek.vue").catch(fallback(Oops))
      },
      {
        path: "line-item/:orderNumber/:lineItemNumber/:frameSpecId",
        name: "lineItemSummary",
        component: () => import("../../pages/retail/LineItemSummary.vue").catch(fallback(Oops))
      },
      {
        path: "find/order",
        name: "retailFindOrder",
        component: () => import("../../pages/retail/RetailFindOrder.vue").catch(fallback(Oops))
      }
    ]
  }
];

export default routes;
